"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComposeEmailPaneButton = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var ApiRequestsContext_1 = require("../../apiRequests/ApiRequestsContext");
var ComposeEmailDialogContainer_1 = require("./ComposeEmailDialogContainer");
var ComposeEmailDialogStyles_1 = require("./ComposeEmailDialogStyles");
/**
 * Make sure to follow the [Rules of Hooks](https://reactjs.org/docs/hooks-rules.html) when consuming this component!
 * Hooks have bitten me in the past since the components I wrote were consumed in a loop, fortunately this component is consumed in
 * [DatabaseDownstreamOwnersPane], [FlowDownstreamOwnersPane], [DatasourceDownstreamOwnersPane], and [TableDownstreamOwnersPane]
 * so this implementation very clearly follows the rules of hooks.
 * Also, since it is not exposed in DataCatClient.ts it isn't supported by the external contract of data catalog client components 😄
 */
function ComposeEmailPaneButton(props) {
    var apiRequests = React.useContext(ApiRequestsContext_1.ApiRequestsContext);
    var _a = React.useState(false), hasPermission = _a[0], setHasPermission = _a[1];
    var _b = React.useState(false), isDialogOpen = _b[0], setIsDialogOpen = _b[1];
    React.useEffect(function () {
        apiRequests.canUserSendImpactAnalysisEmail({ contentId: props.contentId, contentType: props.contentType })
            .then(function (r) { return setHasPermission(r); })
            .catch(function (_) { return; });
    }, [props.contentId, props.contentType, apiRequests] // Don't re-run the permissions check every time someone (un)checks a box
    );
    var launchDialog = function () { return setIsDialogOpen(true); };
    var closeDialog = function () { return setIsDialogOpen(false); };
    function sendEmailAndCloseDialog(a) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, apiRequests.sendImpactAnalysisEmailAndShowToast({
                                contentType: props.contentType,
                                contentId: props.contentId,
                                subject: a.subjectText,
                                body: a.bodyText,
                                userIds: Object.keys(props.selectedUserIds)
                            })];
                    case 1:
                        _b.sent();
                        // TODO: remove toasting from vizportalclient and do that here
                        closeDialog();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = _b.sent();
                        // TODO: remove toasting from vizportalclient and do that here
                        closeDialog();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var hasSelection = Object.keys(props.selectedUserIds).length >= 1;
    var buttonEnabled = hasPermission && hasSelection;
    var tooltipText = !hasPermission
        ? Localize_1.Messages.SendEmailButtonNoPermissions()
        : !hasSelection ? Localize_1.Messages.SendEmailButtonNoSelection() : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(widgets_1.ButtonWidget, { handleClick: launchDialog, buttonType: widgets_1.ButtonType.Outline, style: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.emailButtonStyle, disabled: !(buttonEnabled), testId: ComposeEmailDialogStyles_1.ComposeEmailDialogStyles.TEST_ID('compose-button'), title: tooltipText }, Localize_1.Messages.SendEmail()),
        isDialogOpen && (React.createElement(ComposeEmailDialogContainer_1.ComposeEmailDialogContainer, { selectedUserIds: props.selectedUserIds, dismissDialog: closeDialog, submitResult: sendEmailAndCloseDialog }))));
}
exports.ComposeEmailPaneButton = ComposeEmailPaneButton;
//# sourceMappingURL=ComposeEmailPaneButton.js.map